import { Card, Col, Container, Row, Button } from "react-bootstrap";
import Background from "../../image/background7.jpg";

export default function Coverview() {
    // console.log(PlaceHolderImage);
    return(
    <>
    <Container fluid style={{background: "url(" + Background + ") no-repeat fixed center"}}>
        <Container>
        <Row className="justify-content-center section">
            <Col md="8" sm="12" className="image-over-section">
            <p style={{textAlign:"center", fontSize:"1.12em"}}>My courses are learning adventures that are anchored in a spirit of co-learning and dialogue. The pedagogy is learner centred, immersive and experiential. In my teaching, which I love to re-invent as a Co-Learning Adventure, I am inspired by the philosophy of education expounded by the great scholars Aurobindo, Tagore & Krishnamurti. It has been my experience that when there is a creative space provided for the learner to explore, it results in deep learning, new knowledge creation and possibilities of great transformation. IIT Delhi recognised my innovations in teaching with the Teaching Excellence Award in 2011.</p>
            </Col>
        </Row>
        </Container>
        </Container>
        <Container>
        <Row className="justify-content-center section">
            <Col sm="6" style={{marginBottom:"16px"}}>
                <Card className="h-100">
                    <img as="img" src={process.env.PUBLIC_URL+"/data/images/tech_alt.jpg"} />
                    <Card.Body>
                        <Card.Title>
                            Technology Alternatives for Rural Development (RDL730)
                        </Card.Title>
                        <Card.Text>
                            The course objective is to introduce the paradigm of alternative and appropriate technologies to enable rural communities to creatively prosper in the framework of Samajikta (Social Cohesion), Parasparata (Complementarity), Samriddhi (Natural Abundance) and Saundarya Drishti (Aesthetics & Beauty).
                        </Card.Text>
                    </Card.Body>
                    <Card.Footer>
                        <Button href="./rdtalternative" variant="primary">Read more <i className="bi bi-arrow-right"></i></Button>
                    </Card.Footer>
                </Card>
            </Col>

            <Col sm="6" style={{marginBottom:"16px"}}>
                <Card className="h-100">
                <img as="img" src={process.env.PUBLIC_URL+"/data/images/traditional_knowledge.jpg"} />
                    <Card.Body>
                        <Card.Title>
                            Traditional Knowledge and Values (VEL710)
                        </Card.Title>
                        <Card.Text>
                            The primary objective of the course is to introduce students to the social and cultural values inherent in Traditional Knowledge Systems (TKS) that are practised by communities. The course also endeavours to understand the contemporary significance of these values and knowledge systems for moving towards a harmonious and sustainable global world order.
                        </Card.Text>
                        
                    </Card.Body>
                    <Card.Footer>
                        <Button href="./traditionalknowledge" variant="primary">Read more <i className="bi bi-arrow-right"></i></Button>
                    </Card.Footer>
                </Card>
            </Col>

            <Col sm="6" style={{marginBottom:"16px"}}>
                <Card className="h-100">
                <img as="img" src={process.env.PUBLIC_URL+"/data/images/rural_innovation.jpg"} />
                    <Card.Body>
                        <Card.Title>
                            Rural Innovation and Entrepreneurship (RDL780)
                        </Card.Title>
                        <Card.Text>
                            This course provides learners with deep insights about Rural Innovation and Entrepreneurship. Based on diverse ground experiences, the course provides a comprehensive knowledge of the rural entrepreneurial ecosystem in diverse cultural contexts. The course amplifies students’ innate ability to think beyond textbook concepts and enables them to explore development of innovative pathways to deliver products, services and systems for rural communities.
                        </Card.Text>
                    </Card.Body>
                    <Card.Footer>
                        <Button href="./entrepreneurship" variant="primary">Read more <i className="bi bi-arrow-right"></i></Button>
                    </Card.Footer>
                </Card>
            </Col>

            <Col sm="6" style={{marginBottom:"16px"}}>
                <Card className="h-100">
                <img as="img" src={process.env.PUBLIC_URL+"/data/images/dti.jpg"} />
                    <Card.Body>
                        <Card.Title>
                            Design Thinking and innovation (DTI)
                        </Card.Title>
                        <Card.Text>
                        The IITD Design Thinking and Innovation (DTI) programme is a 20-Weeks programme that powerfully introduces the principles and practice of Design Thinking, enhanced by insights into Generative AI. Taught by leading faculty from IIT Delhi and industry experts, the programme covers the latest in design thinking methodologies and the transformative impact of AI on creative processes.
                        </Card.Text>
                    </Card.Body>
                    <Card.Footer>
                        <Button href="./dti" variant="primary">Read more <i className="bi bi-arrow-right"></i></Button>
                    </Card.Footer>
                </Card>
            </Col>
        </Row>
    </Container>
    </>
    )
}